import { PaginatedSearchRequestDto } from "./PaginatedSearchRequestDto";


export type UserSortType = "name" | "printcount" | "printrequestcount" | "group" | "username" | "status" | "id" | null;

export class PaginatedUserSearchRequestDto extends PaginatedSearchRequestDto {
  groupName: string | null = null;
  status: 'Active' | 'Inactive' | null = null;

  // Sort
  sortBy: UserSortType = null;
  sortDescending: boolean | null = null;
  
  constructor(init?: Partial<PaginatedUserSearchRequestDto>) {
    super();
    if (init) Object.assign(this, init);
  }
}
